import React, { FC, memo, useCallback, useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";
import styles from "./program-job-card.module.scss"
// import { USRemover } from "./Programs";
import ArrowRight from "@/SvgIcons/ArrowRight";
import {
  GAEvent,
  GA_EVENTS,
  GA_EVENTS_PAYLOAD,
  IProgramPageSessionData,
} from "@/helpers/gaEvents";
import { pushToDataLayer } from "@/helpers/gtag";
import { usePlatformAndOS } from "@/helpers/usePlatformAndOS";
import { useDeviceInfo } from "@/helpers/userDeviceType";
import { getGAPayload } from "@/helpers/getGAPayload";
import { StorageService } from "@/helpers/storage.service";
import { useQueryParams } from "@/helpers/useQueryParams";
import { getGlobalStateValue } from "@/context/utils";
import { PROGRAMS } from "@/components/molecules/ProgramMenu/constants";
import SponsoredLogo from "@/components/atoms/SponsoredLogo";
import { USRemover } from "../HeaderOpt/Programs";
interface Program {
  url: string;
  IconUrl: { url: string };
  Title: string;
  year: string;
  sponsoredLogo?: string
  isExternal: boolean;
  signifiers?: {
    tagName?: string;
    hexCode?: string;
  };
}
interface ProgramCardProps {
  program: Program;
  programsDetails: {
    categoryTitle: string;
    programsList: Program[];
    categoryParentTitle: string;
  };
  isMobile?: boolean;
  onCloseHandler?: (href:string) => void;
}


  const getSponsoredLogo = (type) => {
    switch (type) {
      case "PAYTM":
      case "SCHOOL_OF_AI":
      case "HCL_TECH":
      case "TCS_ION":
      case "KPMG":
      case "WOMEN":
        return (
          <div className={styles.sponsoredBy}>
            <SponsoredLogo type={type} />
          </div>
        );
      default:
        return null;
    }
  };

const ProgramJobCard: FC<ProgramCardProps> = ({
  program,
  programsDetails,
  isMobile = false,
  onCloseHandler
}) => {
  const searchParams = useQueryParams();
  const [pageTitle, setPageTitle] = useState<string>("");
  const [pageReferrer, setPageReferrer] = useState<string>("");
  const { platform = "", os = "", version = "" } = usePlatformAndOS();
  const deviceType = useDeviceInfo();
  const { signifiers,isExternal=false } = program;
  const tagName = signifiers?.tagName || null;
  const hexCode = signifiers?.hexCode || null;

  const isMbaCard = useCallback(() => {
    return (
      (program?.Title.toLowerCase().includes("mba") &&
        `/${program?.url}` === PROGRAMS[1]?.url) ||
      false
    );
  }, [program?.Title, program?.url]);

  const selectedCategoryParent =
    programsDetails.categoryParentTitle === "INDUSTRY-ALIGNED PROGRAMS"
      ? "INDUSTRY-ALIGNED PROGRAMS In collaboration with"
      : programsDetails.categoryParentTitle;

  const { PROGRAM_TAB_MBA, NAVIGATION_CLICK } = GAEvent;

  useEffect(() => {
    if (isMbaCard) {
      setPageReferrer(document.referrer);
      setPageTitle(document.title);
      const handleTitleChange = () => {
        setPageTitle(document.title);
      };
      document.addEventListener("titlechange", handleTitleChange);
      return () => {
        document.removeEventListener("titlechange", handleTitleChange);
      };
    }
  }, []);

  const handleGaClick = () => {
    if (isMbaCard) {
      const gaData = GA_EVENTS_PAYLOAD.get(PROGRAM_TAB_MBA);
      const gaOtherPayloadInfo = {
        platform,
        deviceType,
        version,
        pageTitle,
        pageReferrer,
        pageUrl: typeof window !== "undefined" ? window.location.href : "",
      };
      const sessionData: IProgramPageSessionData = {
        isNavbarClick: true,
        isMbaPage: true,
      };
      StorageService.set("programDetailsGAInfo", sessionData);
      const gaPayload = getGAPayload(gaData, searchParams, gaOtherPayloadInfo);
      pushToDataLayer(gaPayload);
    } else {
      const sessionData: IProgramPageSessionData = {
        isNavbarClick: true,
        isMbaPage: false,
      };
      StorageService.set("programDetailsGAInfo", sessionData);
    }
  };

  const handleGaClick2 = (payload = {}) => {
    const gaPaylaod = GA_EVENTS.get(NAVIGATION_CLICK);
    pushToDataLayer({ ...gaPaylaod, ...payload });
  };

  return (
    <Link prefetch={false}
      href={isExternal?`${program.url}`:`${program.url?.startsWith('https')? program.url : process.env.NEXT_PUBLIC_HOST_URL + program.url}`}
      className={styles.card}
      aria-label={`Go to ${program.Title}`}
      target={isExternal ? "_blank" : "_self"}
      onClick={() => {
        handleGaClick();
        handleGaClick2({
          cta_text: program?.Title || "",
          category: "Programs",
          sub_category: selectedCategoryParent || "Program wise",
          section_name: isMobile ? "hamburger" : "header",
          redirection_url: `/${program?.url}`,
          page_type: getGlobalStateValue("pageType") || "Home Page",
          header_title: programsDetails.categoryTitle || "NA",
        });
        onCloseHandler(`/${program.url}`) 
      }}
    >
      <Image
        src={program?.IconUrl?.url}
        alt={program.Title}
        height={25}
        width={25}
        className={styles.programIcon}
        loading="lazy"
        decoding="async"
      />
      <span className={styles.cardTitle}>
        {program.Title} 
        <ArrowRight
          color="#1a325d"
          width={19}
          height={19}
          className={styles.rightArrow}
        />
      </span>
      {program.sponsoredLogo == "MEDAVERSITY" && <div className={styles.sponsoredBy}>
        <SponsoredLogo type="MEDAVERSITY" />
      </div>}
    {/* REVIEW HERE */}
      {getSponsoredLogo(program.sponsoredLogo)}
      <span className={styles.duration}>{program.year}</span>
      {tagName && (
        <span
          className={styles.cardTag}
          style={{ backgroundColor: hexCode || "transparent" }}
        >
          {USRemover(tagName)}
        </span>
      )}
    </Link>
  );
};

export default memo(ProgramJobCard);
